import { useAppContext } from "@/appContext";
import TranscriptChat from "./TranscriptChat";
import { useMemo, useState } from "react";
import Loading from "react-loading";
import Livekit from "./Livekit";

// Component for displaying the transcript of a session
const Transcript = () => {
  const { state } = useAppContext();

  // Memoize the script to avoid unnecessary re-renders
  const script = useMemo(() => {
    if (state.currentQuestion >= 0) {
      if (state.session[state.currentQuestion].fullprompt.length <= 0)
        return state.session[state.currentQuestion].prompt;
      return state.session[state.currentQuestion].fullprompt;
    }
    return [];
  }, [
    state.currentQuestion,
    state.session[state.currentQuestion]?.fullprompt,
    state.session[state.currentQuestion]?.prompt,
  ]);

  return (
    <div className="flex h-[100vh] overflow-hidden py-[30px] ml-3 text-left flex-col">
      {(state.isAssessment||state.isPractice) && (
        <div
          className={
            state.showVideo ? "flex justify-center items-center" : "hidden"
          }
        >
          <Livekit />
        </div>
      )}
      <div className="flex flex-col gap-4 justify-start items-start p-0 m-0 overflow-auto">
        {script.map((chat, i) => (
          <TranscriptChat
            isAI={chat.role !== "user"}
            text={chat.content}
            key={i}
          />
        ))}
        {state.processing && (
          <div className="loading mt-4 align-self-center">
            <Loading type="bubbles" color="#000000" height={200} width={100} />
          </div>
        )}
      </div>
    </div>
  );
};

export default Transcript;
